import React, { useMemo, useState } from 'react';
import {
  Container,
  Option,
  OptionWrapper,
  Title,
  DownIcon,
  SubRow,
  Table,
  ToggleButton,
  UpIcon,
  BetbleLink,
  SiteLogo,
  BetbleSite
} from './styled';
import InternationalOddsSubTable from './SubTable';

const InternationalOdds = ({ data, gameData }) => {
  const [selectedTab, setSelectedTab] = useState('windrawloss');
  const handleChangeTab = (tab) => {
    setSelectedTab(tab);
  };
  return (
    <Container>
      <Title>
        배당 현황
        <OptionWrapper>
          <Option
            isSelected={selectedTab === 'windrawloss'}
            onClick={() => handleChangeTab('windrawloss')}
          >
            일반
          </Option>
          <Option
            isSelected={selectedTab === 'handicap'}
            onClick={() => handleChangeTab('handicap')}
          >
            핸디캡
          </Option>
          <Option
            isSelected={selectedTab === 'unover'}
            onClick={() => handleChangeTab('unover')}
          >
            언더/오버
          </Option>
        </OptionWrapper>
      </Title>

      <Table>
        <colgroup>
          <col width={186} />
          <col width={100} />
          <col width={100} />
          <col width={100} />
          <col width={100} />
          <col width={54} />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>기준</th>
            <th>{selectedTab === 'unover' ? '언더' : '승'}</th>
            <th>무</th>
            <th>{selectedTab === 'unover' ? '오버' : '패'}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.internationals.map((odds) => (
            <OddsRow
              key={odds.siteName + selectedTab}
              data={odds}
              type={selectedTab}
              gameData={gameData}
            />
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

const siteLogos = {
  bet365: 'BET365',
  '1xBet': 'XBET',
  '10Bet': 'TENBET',
  SBOBET: 'SBOBET',
  Dafabet: 'DAFABET',
  'William Hill': 'WILLIAM',
  BETMAN: 'BETMAN'
};

const OddsRow = ({ data, title, type, gameData }) => {
  const { siteName, getOdds } = data;
  const { detail } = gameData;
  const { betbleUri } = detail;
  const { winLoseOdds, handicapOdds, underOverOdds } = getOdds;
  const [historyTable, toggleHistoryTable] = useState({
    open: false,
    id: null,
    type: 'win'
  });

  const { win, draw, loss, option } = useMemo(() => {
    if (type === 'windrawloss') {
      return {
        win: winLoseOdds.win,
        draw: winLoseOdds.draw,
        loss: winLoseOdds.loss,
        option: ''
      };
    } else if (type === 'handicap') {
      return {
        win: handicapOdds.win,
        draw: handicapOdds.draw,
        loss: handicapOdds.loss,
        option: handicapOdds.option
      };
    } else {
      return {
        win: underOverOdds.win,
        draw: underOverOdds.draw,
        loss: underOverOdds.loss,
        option: underOverOdds.option
      };
    }
  }, [type]);

  const onClickOddsHistory = () => {
    if (
      win.isChange === null &&
      draw.isChange === null &&
      loss.isChange === null
    ) {
      return;
    } else {
      if (historyTable.open) {
        onClosePopup();
      } else {
        let id = null;
        let type;

        if (!!win.isChange) {
          id = win.id;
          type = 'win';
        } else if (!!draw.isChange) {
          id = draw.id;
          type = 'draw';
        } else if (!!loss.isChange) {
          id = loss.id;
          type = 'loss';
        }

        toggleHistoryTable({ open: true, id, type });
      }

      return;
    }
  };

  const onClosePopup = () => {
    toggleHistoryTable({ open: false, id: null, type: 'win' });
  };

  const isBetble = siteName === 'BETBLE';

  const handleClickBetbleLink = (event) => {
    event.stopPropagation();
    let type = 0;

    if (detail.getTracker.status === 'progress') {
      type = 1;
    }
    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;
    window.open(url);
  };

  const siteLogo = siteLogos[siteName] || null;
  return [
    <tr
      key={'row'}
      onClick={() => onClickOddsHistory()}
      className={historyTable.open ? 'on' : ''}
    >
      <td>
        {siteLogo !== null && <SiteLogo siteLogo={siteLogo} />}
        {siteLogo === null && !isBetble && <>{siteName.toLowerCase()}</>}
        {isBetble && <BetbleSite />}

        {/*{isBetble && betbleUri && (*/}
        {/*  <BetbleLink onClick={handleClickBetbleLink}>*/}
        {/*    <span>베팅하기</span>*/}
        {/*  </BetbleLink>*/}
        {/*)}*/}
      </td>
      <td>
        <em className={type === 'unover' ? 'unover' : ''}>
          {type !== 'windrawloss' && !!option && option}
        </em>
      </td>
      <td>
        {win.value}
        {win.isChange === 'up' && <UpIcon />}
        {win.isChange === 'down' && <DownIcon />}
      </td>
      <td>
        {draw.value}
        {draw.isChange === 'up' && <UpIcon />}
        {draw.isChange === 'down' && <DownIcon />}
      </td>
      <td>
        {loss.value}
        {loss.isChange === 'up' && <UpIcon />}
        {loss.isChange === 'down' && <DownIcon />}
      </td>
      <td>
        <ToggleButton viewSub={historyTable.open} />
      </td>
    </tr>,
    historyTable.open && (
      <SubRow className={'subRow'} key={'subRow'}>
        <td colSpan={6}>
          <InternationalOddsSubTable
            selectedTab={type}
            oddsId={historyTable.id}
            type={historyTable.type}
            close={onClosePopup}
          />
        </td>
      </SubRow>
    )
  ];
};

export default InternationalOdds;
